import { Typography } from "@novaescola/eva-react-v2/lib/Typography";
import React, { useEffect, useRef } from "react";
import ReactGA from "react-ga";
import { useInView } from "../../hooks/useInView";
import { isContentSchoolProjects } from "../../data/utils";

const Tags = ({ data }) => {
  const tagsRef = useRef(null);
  const isInView = useInView(tagsRef);

  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    const previewEventSent = window.dataLayer.filter(
      (el) =>
        el.label &&
        el.label ===
          "SITE: Click - Nova página de conteúdo - Veja mais sobre - bloco visualizado"
    );

    if (isInView && previewEventSent.length === 0) {
      window.dataLayer.push({
        event: "block_visualization",
        label:
          "SITE: Click - Nova página de conteúdo - Veja mais sobre - bloco visualizado",
      });
    }
  }, [isInView])

  return (
    <>
      <Typography variant="title" size={4} asChild className="eva-margin-top-4">
       <h2 ref={tagsRef}>Veja mais sobre</h2>
      </Typography>
      <div className="tags"
        style={{
          display: 'flex',
          paddingTop: '60px',
          marginBottom: '60px',
          justifyContent: 'center',
          flexWrap: 'wrap',
          gap: '10px',
        }}
      >
        {data.content.tags.map((tagInfo, index) => (
          <a
            href={tagInfo.tag == "Comunidade Conectando Saberes" ? "https://novaescola.org.br/tudo-sobre/comunidade-nova-escola/" : tagInfo.uri}
            key={`tag${index}`}
            className="eva-tag cinza-700 small has-link"
            data-track={`Nova página de conteúdo - botão tag ${index}`}
            onClick={() => {
              ReactGA.event({
                action: "Click",
                category: "SITE",
                label: `Nova página de conteúdo - botão tag ${index}`,
              });
            }}
          >
            {tagInfo.tag}
          </a>
        ))}
      </div>
    </>
  );
};

export default Tags;
